import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt, { useIsMobile } from '../../shared/theme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${props => (dt(props).theme.isMobile ? 48 : 40)}px;
`;

const Hr = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  border: 0;
  justify-content: center;
  overflow: visible;

  &:before {
    display: inline-block;
    font-weight: ${props => dt(props).theme.fontWeightRegular};
    font-size: 36px;
    letter-spacing: 9px;
    color: ${props => dt(props).theme.primaryColor};
    content: "${() => new Array(3).fill('\\00b7').join('')}";
  }
`;

const Text = styled.span`
  font-size: 19px;
  line-height: 120%;
  letter-spacing: -0.011em;
  margin: 8px 0px;
  text-align: center;
`;

const Button = styled.button`
  height: 40px;
  width: 222px;
  font-size: 14px;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightBold};
  line-height: 120%;
  text-transform: uppercase;
  background-color: ${props => dt(props).theme.bodyBackgroundColor};
  border: 1px solid ${props => dt(props).theme.secondaryColor};
  border-radius: 4px;
  outline: none;
  margin-top: 16px;

  &:hover {
    border-color: #627484;
  }

  &:focus {
    outline: none;
    border-color: ${props => dt(props).theme.bodyColor}
  }
`;

export default function SeriesCta({ copy, name, url }) {
  const openSeriesPage = e => {
    e && e.preventDefault();

    window.location = url;
  };

  const isMobile = useIsMobile();

  return (
    <Container>
      {!isMobile && <Hr />}
      <Text>{copy}</Text>
      <Button type="button" onClick={openSeriesPage}>{name}</Button>
    </Container>
  );
}

SeriesCta.propTypes = {
  copy: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
